import Reflux from 'reflux';
import * as Immutable from 'immutable';
import type { WizardSubmitPayload } from 'logic/authentication/directoryServices/types';
import { singletonActions } from 'logic/singleton';
import type { RefluxActions } from 'stores/StoreTypes';

import { OidcSubmitPayload } from 'authentication/components/oidc/config/types';

import GroupSyncBackend from '../../logic/directoryServices/GroupSyncBackend';
import type { GroupSyncBackendJSON } from '../../logic/directoryServices/GroupSyncBackend';
import Group from '../../logic/directoryServices/Group';

export type LoadGroupsResponse = {
  success: boolean,
  message: string,
  errors: Immutable.List<string>,
  list: Immutable.List<Group>,
};

export type LoadBackendResponse = {
  backend: GroupSyncBackend,
};

type GroupSyncBackendPayload = Omit<GroupSyncBackendJSON, 'id'>;

export type LoadGroupsPayload = {
  auth_service_backend_id: string | null | undefined,
  auth_service_backend_configuration: WizardSubmitPayload | OidcSubmitPayload,
  team_sync_backend_configuration: GroupSyncBackendPayload,
};

export type ActionsType = {
  create: (backendId: string, payload: GroupSyncBackendPayload) => Promise<LoadBackendResponse | null | undefined>,
  delete: (backendId: string) => Promise<void>,
  load: (backendId: string) => Promise<LoadBackendResponse | null | undefined>,
  loadGroups: (payload: LoadGroupsPayload) => Promise<LoadGroupsResponse>,
  update: (backendId: string, payload: GroupSyncBackendPayload) => Promise<LoadBackendResponse | null | undefined>,
};

const GroupSynchronizationActions: RefluxActions<ActionsType> = singletonActions(
  'enterprise.authentication.directoryService.GroupSync',
  () => Reflux.createActions({
    create: { asyncResult: true },
    delete: { asyncResult: true },
    load: { asyncResult: true },
    loadGroups: { asyncResult: true },
    update: { asyncResult: true },
  }),
);

export default GroupSynchronizationActions;
